import { useAccount } from 'src/hooks'
import { useStyles } from './styles'
import { Avatar, Skeleton } from '@mui/material'

const AccountIcon = () => {
  const { data: account } = useAccount()
  const classes = useStyles()

  return (
    <div className={classes.imageWrapper}>
      {account ? (
        <div>
          <Avatar
            alt={account.account_holder}
            src={account.image_medium || account.image}
            className={classes.image}
          />
        </div>
      ) : (
        <Skeleton width={65} height={65} variant="circular" />
      )}
    </div>
  )
}

export { AccountIcon }
